import { memo } from "react";
import { TableStatus } from "../../types/TableStatuses";
import { Bubble } from "./Bubble";
import "../../styles/circles.css";

type Props = {
  status?: TableStatus;
  /**
   * Override the text displayed in the bubble. By default, it is the TableStatus.
   */
  text?: string;
};

const TableStatusBubble = (props: Props) => {
  if (props.status == null || props.status === "MISSING") {
    return null;
  }
  const statusText =
    props.status.charAt(0).toUpperCase() + props.status.slice(1).toLowerCase();

  let className = "";
  switch (props.status) {
    case "MATCH": {
      className = "normal";
      break;
    }
    case "ERROR": {
      className = "error";
      break;
    }
    case "EMPTY": {
      className = "darkgreen";
      break;
    }
    case "REUSE": {
      className = "notification";
      break;
    }
  }

  return (
    <Bubble
      text={props.text ?? statusText}
      className={className}
      style={{ marginLeft: 5 }}
    />
  );
};
const MemoTableStatusBubble = memo(TableStatusBubble);
export { MemoTableStatusBubble as TableStatusBubble };
